// extracted by mini-css-extract-plugin
export default {"modalFooter":"CredentialsModal_modalFooter__+DlY7","content":"CredentialsModal_content__iwU37"};